import React from 'react'

export default function Section({children}) {
    return (
        <div className="container mx-auto py-4 md:py-16 px-2">
            {children}
        </div>
    )
}
